export const HomeCareLeadDaysNeededOptions = [
    { value: "sun", label: "Sun" },
    { value: "mon", label: "Mon" },
    { value: "tue", label: "Tue" },
    { value: "wed", label: "Wed" },
    { value: "thu", label: "Thu" },
    { value: "fri", label: "Fri" },
    { value: "sat", label: "Sat" },
];
export const homeCareLeadDaysNeededValues = HomeCareLeadDaysNeededOptions.map(option => option.value);
export const HomeCarePartnerIntegrations = ["wellSkyPersonalCare", "axisCare"];
const homeCarePartnerDescriptors = {
    wellSkyPersonalCare: {
        partnerName: "WellSky Personal Care",
        recordNoun: "prospect",
    },
    axisCare: {
        partnerName: "AxisCare",
        recordNoun: "client",
    },
};
export const homeCarePartnerDescriptor = (integration) => homeCarePartnerDescriptors[integration];
export const isHomeCarePartnerIntegration = (value) => HomeCarePartnerIntegrations.includes(value);
export const homeCarePartnerNameFor = (integration) => isHomeCarePartnerIntegration(integration)
    ? homeCarePartnerDescriptors[integration].partnerName
    : integration;
//# sourceMappingURL=home-care-lead.js.map